import React, { useContext } from "react";
import styled from "styled-components";
import { FaInfo } from "react-icons/fa";
import { DataContext } from "../../../contexts/DataContext";
import moment from "moment";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const InfoIcon = styled(FaInfo)`
  margin-right: 2px;
  position: absolute;
  left: 3px;
  font-size: 1.5em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  font-size: 1.2em;
  align-items: center;
`;
const Footer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: auto;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Category = styled.div`
  font-size: 10px;
`;
const Result = styled.div`
  font-size: 12px;
`;
export default function Opta65({ item, game, previewGraphic }) {
  const decisions = [
    {
      id: 329,
      category: "GOAL CHECK",
      value: "GOAL AWARDED",
      opposite: "GOAL NOT AWARDED",
    },
    {
      id: 330,
      category: "PENALTY CHECK",
      value: "PENALTY AWARDED",
      opposite: "PENALTY NOT AWARDED",
    },
    {
      id: 331,
      category: "PENALTY CHECK",
      value: "PENALTY NOT AWARDED",
      opposite: "PENALTY AWARDED",
    },
    { id: 332, category: "CARD CHECK", value: "CARD UPGRADE" },
    { id: 333, category: "MISTAKEN IDENTITY", value: "MISTAKEN IDENTITY" },
    { id: 334, category: "OTHER", value: "OTHER" },
    {
      id: 341,
      category: "GOAL CHECK",
      value: "GOAL NOT AWARDED",
      opposite: "GOAL AWARDED",
    },
    {
      id: 342,
      category: "CARD CHECK",
      value: "RED CARD",
      opposite: "NO RED CARD",
    },
  ];

  function preview() {
    previewGraphic("VAR", {
      game: game,
      decision: decisions?.find((d) => {
        return item?.qualifier?.find((q) => q?.qualifierId === 335);
      })
        ? decisions?.find((d) => {
            return item?.qualifier?.find((q) => q?.qualifierId === d?.id);
          })?.value
        : decisions?.find((d) => {
              return item?.qualifier?.find((q) => q?.qualifierId === 336);
            })
          ? decisions?.find((d) => {
              return item?.qualifier?.find((q) => q?.qualifierId === d?.id);
            })?.opposite
          : decisions?.find((d) => {
              return item?.qualifier?.find((q) => q?.qualifierId === d?.id);
            })?.category,
    });
  }

  return (
    <Main
      onClick={(e) => {
        preview();
      }}
    >
      <Title>
        <InfoIcon />
        VAR Decision
      </Title>
      <Content>
        <Column>
          <Category>
            {decisions?.find((d) => {
              return item?.qualifier?.find((q) => q?.qualifierId === 335);
            })
              ? decisions?.find((d) => {
                  return item?.qualifier?.find((q) => q?.qualifierId === d?.id);
                })?.value
              : decisions?.find((d) => {
                    return item?.qualifier?.find((q) => q?.qualifierId === 336);
                  })
                ? decisions?.find((d) => {
                    return item?.qualifier?.find(
                      (q) => q?.qualifierId === d?.id,
                    );
                  })?.opposite
                : decisions?.find((d) => {
                    return item?.qualifier?.find(
                      (q) => q?.qualifierId === d?.id,
                    );
                  })?.category}
          </Category>
          <Result>
            {decisions?.find((d) => {
              return item?.qualifier?.find((q) => q?.qualifierId === 335);
            })
              ? "Ref Decision Confirmed"
              : decisions?.find((d) => {
                    return item?.qualifier?.find((q) => q?.qualifierId === 336);
                  })
                ? "Ref Decision Cancelled"
                : ""}
          </Result>
        </Column>
      </Content>
      <Footer>
        <div>
          {item.timeMin?.toString().padStart(2, "0") +
            ":" +
            item.timeSec?.toString().padStart(2, "0")}
        </div>
      </Footer>
    </Main>
  );
}
